// extracted by mini-css-extract-plugin
export default {"divider":"Ar3mWv","compact":"_1bQdi"};